// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bd0236c7","239":"9e102543","389":"bed78402","732":"a337b38c","977":"43c4b5f3"}[chunkId] + ".chunk.js";
};